const WINDOW_ID_KEY = 'dt_window_id';

const ensureWindowId = () => {
  if (typeof window === 'undefined') {
    return 'server';
  }
  let windowId = sessionStorage.getItem(WINDOW_ID_KEY);
  if (!windowId) {
    windowId = `w_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    sessionStorage.setItem(WINDOW_ID_KEY, windowId);
  }
  return windowId;
};

export const getWindowScopedCookieKey = (baseKey: string) => {
  const windowId = ensureWindowId();
  return `${baseKey}_${windowId}`;
};

export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }
  const cookies = document.cookie ? document.cookie.split('; ') : [];
  for (const cookie of cookies) {
    const [key, ...valueParts] = cookie.split('=');
    if (key === name) {
      return decodeURIComponent(valueParts.join('='));
    }
  }
  return null;
};

export const setCookie = (name: string, value: string, days = 30) => {
  if (typeof document === 'undefined') {
    return;
  }
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/`;
};

export const deleteCookie = (name: string) => {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${name}=; max-age=0; path=/`;
};
